<template>
  <div id="main">

    <div class="header">

      <div class="headtitle">
        <h4>智慧城市* 智能路牌 </h4>

      </div>
      <button @click="out">退出</button>
    </div>
    <div class="aside">
      <div class="search">
        <input type="search" placeholder="请输入设备名称或设备号" disabled>
      </div>
      <div class="ser">
        <div class="list_title">设备列表</div>
        <div class="list">
          <ul>
            <li v-for="(i,j) in liscon" v-bind:key="j" @click="liclick(i.imei,j)" :class="state==j?'checked':''">
              <i class="iconfont" :class="i.color">&#xe697;</i>
              <span>{{i.dc800Device.name}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="main">
      <div id="allmap"></div>
    </div>
    <div class="context">
      <div class="select">
        <select id="demo">
          <option value="1" disabled selected>请选择状态</option>
        </select>
      </div>
      <div class="con_title">
        <h3 @click="onOff=true">设备信息</h3>
        <h3 @click="postaxios">历史记录</h3>
      </div>

      <div class="con_text" v-if="onOff">
        <ul>
          <li class="title"><i class="iconfont" :class="li_con.color">&#xe697;</i> <span> 智能路牌</span></li>
          <li>撞击：<span :class="datecolor?'':'color'"> {{li_con.impact}}</span></li>
          <li>角度：<span :class="datecolor?'':'color'"> {{li_con.angle}}</span></li>
          <li>时间：<span :class="datecolor?'':'color'"> {{li_con.eventTime}}</span></li>
          <li>imei：<span :class="datecolor?'':'color'"> {{li_con.imei}}</span></li>

          <li>经度：<span :class="datecolor?'':'color'">{{li_con.lng}}</span></li>
          <li>纬度：<span :class="datecolor?'':'color'">{{li_con.lat}}</span></li>
          <li>低电量：<span :class="datecolor?'':'color'"> {{li_con.battery}}</span></li>
          <li>加速度阈值：<span :class="datecolor?'':'color'"> {{li_con.accelerationThreshold}}</span></li>
          <li>加速度值：<span :class="datecolor?'':'color'"> {{li_con.impactValue}}</span></li>
          <li>位角度阈值：<span :class="datecolor?'':'color'"> {{li_con.angleThreshold}}</span></li>
          <li>周期上报时间：<span :class="datecolor?'':'color'"> {{li_con.interval0}}</span></li>
          <li>紧急状态上报时间：<span :class="datecolor?'':'color'"> {{li_con.interval1}}</span></li>
          <li>闲置状态上报时间：<span :class="datecolor?'':'color'"> {{li_con.interval2}}</span></li>

        </ul>

      </div>
      <div class="history" v-if="!onOff">
        <div class="history_con">
        <div class="setpage">
          <button :disabled="back" @click="backpage()" >上一页</button>
          <button :disabled="goto" @click="gopage()" >下一页</button>
        </div>
          <div class="history_li" v-for="(i,j) in historylist" v-if="i" :key="(i,j)">
            <div class="history_cd" @click="lisnum=j" :class="lisnum!=j?'':'checked'">{{i.eventTime}}</div>
            <ul :class="lisnum!=j?'history_v':'history_v history_u'">
              <li class="title"><i class="iconfont" :class="i.color">&#xe697;</i> <span> 智能路牌</span></li>
              <li>撞击：<span> {{i.impact}}</span></li>
              <li>角度：<span> {{i.angle}}</span></li>
              <li>时间：<span> {{i.eventTime}}</span></li>
              <li>imei：<span> {{i.imei}}</span></li>
              <li>经度：<span>{{i.lng}}</span></li>
              <li>纬度：<span>{{i.lat}}</span></li>
              <li>低电量：<span> {{i.battery}}</span></li>
              <li>加速度阈值：<span > {{i.accelerationThreshold}}</span></li>
              <li>位角度阈值：<span > {{i.angleThreshold}}</span></li>
              <li>紧急状态上报时间：<span > {{i.interval1}}</span></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {Loading} from 'element-ui';
  import iconBlue from '../../assets/img/lupaiblue.png'
  import iconRed from '../../assets/img/lupaired.png'
  import iconGreen from '../../assets/img/lupaiyellow.png'

  export default {
    name: 'RoadSign',
    data() {
      return {
        state: null,
        lists: null,
        iconblue: iconBlue,
        iconRed: iconRed,
        iconGreen: iconGreen,
        li_con: {
          id: '暂时未有信息',
          impact: '暂时未有信息',
          angle: '暂时未有信息',
          eventTime: '暂时未有信息',
          imei: '暂时未有信息',
          incline: '暂时未有信息',
          lat: '暂时未有信息',
          lng: '暂时未有信息',
          battery: '暂时未有信息',
          accelerationThreshold: '暂时未有信息',
          impactValue: '暂时未有信息',
          angleThreshold: '暂时未有信息',
          interval0: '暂时未有信息',
          interval1: '暂时未有信息',
          interval2: '暂时未有信息',
          color: null,
        },
        liscon: null,
        onOff: true,
        loadError: false,
        datecolor: false,
        lisnum: 0,
        useId: localStorage.getItem('userId'),
        // useId: 612,
        markers: [],
        locations: [],
        mapid: [],
        historylist: null,
        historyres: null,
        currentPage:1,
        imei:null,
        back:false,
        goto:false
      }
    },

    methods: {
      liclick(n, m) {
        let loadingInstance = Loading.service({
          lock: true,
          text: '加载中，请稍后',
          spinner: 'el-icon-loading',
          background: "rgba(0,0,0,.5)"
        });
        this.onOff=true;
        this.state = m;
        this.imei = n;
        var _this = this;

        for (var i in _this.markers) {
          _this.markers[i].setAnimation('AMAP_ANIMATION_NONE')
        }
        _this.markers[m].setAnimation('AMAP_ANIMATION_BOUNCE');

        _this.map.setZoomAndCenter(16, _this.locations[m]);

        this.datecolor = true;
        for (let i  in this.liscon) {
          if (this.liscon[i].imei == n) {
            this.li_con = this.liscon[i]
          }
        }
        loadingInstance.close();
         this.currentPage=0;
      },
      postaxios(){
      if(this.imei!=null){
        var _this = this;
        this.onOff=false;

        this.back=true;
        this.goto=false;

        this.$axios({
          method: "get",
          url: "/data/dc800/getHistoryData",
          params:{
            imei:this.imei,
            currentPage:1,
            pageSize:10
          }
        }).then(res => {
          // console.log(res);
          let data = res.data.list;
          for (var i in data) {
            data[i].eventTime = formatTime(res.data.list[i].eventTime);
            data[i].deviceStatus = this.deviceStatus(res.data.list[i].deviceStatus);
            data[i].battery = this.battery(res.data.list[i].battery);
            if (data[i].impact == 1) {
              data[i].color = 'red'
            } else {
              data[i].color = 'blue'
            }
            if(data[i].angleThreshold==null){
              data[i].angleThreshold=0
            }
            if(data[i].interval0==null){
              data[i].interval0=0
            }
            if(data[i].interval2==null){
              data[i].interval2=0
            }
            if(data[i].interval1==null){
              data[i].interval1=0
            }
            if(data[i].impactValue==null){
              data[i].impactValue=0
            }
            data[i].impactValue=data[i].impactValue+'mg';
            data[i].angleThreshold= data[i].angleThreshold+'°'
            data[i].interval0= data[i].interval0+'小时';
            data[i].interval1= data[i].interval1+'分钟';
            data[i].interval2= data[i].interval2+'分钟'
          }
          this.historylist = data;

            // 有下一页不禁用下一页按钮,否则禁用
            res.data.hasNextPage==ture?this.goto=false:this.goto=true;
        }).catch(function (error) {
          if (error) {
            _this.loadError = true
          }
        });
      }
      // console.log('+1ok,当前是'+this.historyres.data.pageNum+'页');
      // this.historyres=null;
      },
      gopage() {
        var _this = this;
        this.$axios({
          method: "get",
          url: "/data/dc800/getHistoryData",
          params:{
            imei:this.imei,
            currentPage:this.currentPage+1,
            pageSize:10
          }
        }).then(res => {
          this.back=false;
          let data = res.data.list;
          for (var i in data) {
            data[i].eventTime = formatTime(res.data.list[i].eventTime);
            data[i].deviceStatus = this.deviceStatus(res.data.list[i].deviceStatus);
            data[i].battery = this.battery(res.data.list[i].battery);
            if (data[i].impact == 1) {
              data[i].color = 'red'
            } else {
              data[i].color = 'blue'
            }
            if(data[i].angleThreshold==null){
              data[i].angleThreshold=0
            }
            if(data[i].interval0==null){
              data[i].interval0=0
            }
            if(data[i].interval2==null){
              data[i].interval2=0
            }
            if(data[i].interval1==null){
              data[i].interval1=0
            }
            if(data[i].impactValue==null){
              data[i].impactValue=0
            }
            data[i].impactValue=data[i].impactValue+'mg';
            data[i].angleThreshold= data[i].angleThreshold+'°'
            data[i].interval0= data[i].interval0+'小时';
            data[i].interval1= data[i].interval1+'分钟';
            data[i].interval2= data[i].interval2+'分钟'
          }
          this.historylist = data;
            //储存页数加一
            this.currentPage+=1;
            // console.log('+1ok,当前是'+res.data.pageNum+'页');
            //没有下一页禁用下一页按钮，有的话打印
            res.data.hasNextPage!=true?this.goto=true:this.goto=false;
        }).catch(function (error) {
          if (error) {
            _this.loadError = true
          }
        });
      },
      backpage() {
        var _this = this;
        this.$axios({
          method: "get",
          url: "/data/dc800/getHistoryData",
          params:{
            imei:this.imei,
            currentPage:this.currentPage-1,
            pageSize:5
          }
        }).then(res => {
          // console.log(res);
          this.goto=false;
          //当前页
          let data = res.data.list;
          for (var i in data) {
            data[i].eventTime = formatTime(res.data.list[i].eventTime);
            data[i].deviceStatus = this.deviceStatus(res.data.list[i].deviceStatus);
            data[i].battery = this.battery(res.data.list[i].battery);
            if (data[i].impact == 1) {
              data[i].color = 'red'
            } else {
              data[i].color = 'blue'
            }
            if(data[i].angleThreshold==null){
              data[i].angleThreshold=0
            }
            if(data[i].interval0==null){
              data[i].interval0=0
            }
            if(data[i].interval2==null){
              data[i].interval2=0
            }
            if(data[i].interval1==null){
              data[i].interval1=0
            }
            if(data[i].impactValue==null){
              data[i].impactValue=0
            }
            data[i].impactValue=data[i].impactValue+'mg';
            data[i].angleThreshold= data[i].angleThreshold+'°'
            data[i].interval0= data[i].interval0+'小时';
            data[i].interval1= data[i].interval1+'分钟';
            data[i].interval2= data[i].interval2+'分钟'
          }
          this.historylist = data;
          //储存页数减一
          this.currentPage-=1;
          // console.log('-1ok,当前是'+res.data.pageNum+'页');
          //判断有没有上一页,有的不禁用
          res.data.hasPreviousPage==true?this.back=false:this.back=true;
        }).catch(function (error) {
          if (error) {
            _this.loadError = true
          }
        });
      },
      out() {
        this.$router.push({path: "/product"});
      },
      loading(a) {//是否显示加载动画
        this.loadFlag = a;
      },
      deviceStatus(n){
        if(n==0){
          return "正常"
        }else if(n==1){
          return "异常"
        }else if(n==2){
          return "维修"
        }
      },
      impact(n) {
        if (n == 0) {
          return '正常'
        } else {
          return '撞击'
        }
      },
      battery(n) {
        if (n == 0) {
          return '充足'
        } else {
          return '不足'
        }
      }
    },
    mounted() {

      let $this = this;
      let useId = $this.useId;
      let map = new AMap.Map('allmap', {
        zoom: 8,
        expandZoomRange: true,
        center:[sessionStorage.getItem('lng'),sessionStorage.getItem('lat')],
        zooms: [3, 20]
      });

      this.loading(true);
      this.$axios({
        method: "get",
          // url: "/data/dc800/getDeviceData?userId=" + useId
        url: "/data/dc800/getRecentData?userId=" + useId
        // url: "http://192.168.1.20:8088/data/dc800/getRecentData?userId=" + useId
      }).then(res => {

        let Data = res.data.data;
        $this.markers=[]
        $this.liscon=[]

        // this.liscon = Data;
        for (let i = 0; i < Data.length; i++) {
          if(Data[i].angleThreshold==null){
            Data[i].angleThreshold=0
          }
          if(Data[i].interval0==null){
            Data[i].interval0=0
          }
          if(Data[i].interval2==null){
            Data[i].interval2=0
          }
          if(Data[i].interval1==null){
            Data[i].interval1=0
          }
          if(Data[i].impactValue==null){
            Data[i].impactValue=0
          }
          Data[i].eventTime = formatTime(Data[i].eventTime);
          Data[i].battery = $this.battery(Data[i].battery);
          Data[i].deviceStatus=$this.deviceStatus(Data[i].deviceStatus);
          Data[i].impact=$this.impact(Data[i].impact);
          Data[i].impactValue=Data[i].impactValue+'mg';
          Data[i].angleThreshold= Data[i].angleThreshold+'°'
          Data[i].interval0= Data[i].interval0+'小时';
          Data[i].interval1= Data[i].interval1+'分钟';
          Data[i].interval2= Data[i].interval2+'分钟'
          chang(Data[i], i)
        }

      });

      function chang(data, n) {
          // 介入坐标转为高德坐标
          var GPS = {
              PI : 3.14159265358979324,
              x_pi : 3.14159265358979324 * 3000.0 / 180.0,
              delta : function (lat, lon) {
              // Krasovsky 1940
              //
              // a = 6378245.0, 1/f = 298.3
              // b = a * (1 - f)
              // ee = (a^2 - b^2) / a^2;
            var a = 6378245.0; //  a: 卫星椭球坐标投影到平面地图坐标系的投影因子。
            var ee = 0.00669342162296594323; //  ee: 椭球的偏心率。
            var dLat = this.transformLat(lon - 105.0, lat - 35.0);
            var dLon = this.transformLon(lon - 105.0, lat - 35.0);
            var radLat = lat / 180.0 * this.PI;
            var magic = Math.sin(radLat);
            magic = 1 - ee * magic * magic;
            var sqrtMagic = Math.sqrt(magic);
            dLat = (dLat * 180.0) / ((a * (1 - ee)) / (magic * sqrtMagic) * this.PI);
            dLon = (dLon * 180.0) / (a / sqrtMagic * Math.cos(radLat) * this.PI);
            return {'lat': dLat, 'lon': dLon};
            },

            //GPS---高德
            gcj_encrypt : function ( wgsLat , wgsLon ) {
                if (this.outOfChina(wgsLat, wgsLon))
                    return {'lat': wgsLat, 'lon': wgsLon};

                var d = this.delta(wgsLat, wgsLon);
                // 转换完成输出
                return {'lat' : wgsLat + d.lat,'lon' : wgsLon + d.lon};
            },
            outOfChina : function (lat, lon) {
                if (lon < 72.004 || lon > 137.8347)
                    return true;
                if (lat < 0.8293 || lat > 55.8271)
                    return true;
                return false;
            },
            transformLat : function (x, y) {
                var ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
                ret += (20.0 * Math.sin(6.0 * x * this.PI) + 20.0 * Math.sin(2.0 * x * this.PI)) * 2.0 / 3.0;
                ret += (20.0 * Math.sin(y * this.PI) + 40.0 * Math.sin(y / 3.0 * this.PI)) * 2.0 / 3.0;
                ret += (160.0 * Math.sin(y / 12.0 * this.PI) + 320 * Math.sin(y * this.PI / 30.0)) * 2.0 / 3.0;
                return ret;
            },
            transformLon : function (x, y) {
                var ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));
                ret += (20.0 * Math.sin(6.0 * x * this.PI) + 20.0 * Math.sin(2.0 * x * this.PI)) * 2.0 / 3.0;
                ret += (20.0 * Math.sin(x * this.PI) + 40.0 * Math.sin(x / 3.0 * this.PI)) * 2.0 / 3.0;
                ret += (150.0 * Math.sin(x / 12.0 * this.PI) + 300.0 * Math.sin(x / 30.0 * this.PI)) * 2.0 / 3.0;
                return ret;
            }
          };
          // 函数返回转换后的高德坐标
        var pointXY = GPS.gcj_encrypt(data.lat,data.lng); 

          // 高德坐标转为地图坐标
        var locations= new AMap.LngLat(pointXY.lon,pointXY.lat) 

          let icon;
          if (data.impact == '正常') {
            icon = $this.iconblue;
            data.color = 'blue'
          } else {
            icon = $this.iconRed;
            data.color = 'red'
          }

          let marker = new AMap.Marker({
            position: locations,
            zIndex: 333,
            icon: new AMap.Icon({
              image: icon,
              size: new AMap.Size(128, 128),  //图标大小
              imageSize: new AMap.Size(48, 48)
            }),
            map: map

          });
          $this.markers.splice(n, 0, marker);
          $this.locations.splice(n, 0, locations);
          $this.map = map;
          $this.mapid.splice(n, 0, marker._amap_id);
          $this.liscon.splice(n,0,data);
          AMap.event.addListener(marker, 'click', function () {
            $this.liclick(data.imei,$this.markers.indexOf(marker));
            $this.li_con = data;
            marker.setAnimation('AMAP_ANIMATION_BOUNCE');
          });
      }
    },
    components: {}
  }

  function formatTime(time) {
    // var localOffset=new Date().getTimezoneOffset()*60;
    // let unixtime = time+localOffset;
    // let unixTimestamp = new Date(unixtime * 1000);
    let unixTimestamp = new Date(time * 1000 + 3600000*8);//本地区毫秒值
        // console.log('转换前的0时区'+time);
        // console.log('本地时间为'+unixTimestamp/1000);
    let Y = unixTimestamp.getFullYear();
    let M = ((unixTimestamp.getMonth() + 1) >= 10 ? (unixTimestamp.getMonth() + 1) : '0' + (unixTimestamp.getMonth() + 1));
    let D = (unixTimestamp.getDate() >= 10 ? unixTimestamp.getDate() : '0' + unixTimestamp.getDate());
    let H = (unixTimestamp.getHours() >= 10 ? unixTimestamp.getHours() : '0' + unixTimestamp.getHours());
    let N = (unixTimestamp.getMinutes() >= 10 ? unixTimestamp.getMinutes() : '0' + unixTimestamp.getMinutes());
    let S = (unixTimestamp.getSeconds() >= 10 ? unixTimestamp.getSeconds() : '0' + unixTimestamp.getSeconds());
    let toDay = Y + '-' + M + '-' + D + " " + H + ":" + N + ":" + S;
    return toDay
  }
</script>

<style scoped>
  @import "../../assets/font/iconfont.css";

  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  ul li {
    white-space: nowrap;
    overflow: hidden;
  }

  .color {
    color: rgba(207, 214, 211, 0.9);
  }

  #main {
    width: 100%;
    height: 100%;
    position: fixed;
    background-color: #ffffff;
  }

  #main .red {
    color: red;
  }

  #main .blue {
    color: #53a1ff;
  }

  #main #allmap {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
  }
  .setpage{
    height: 40px;
    clear: both;
  }

  .setpage button {
    height: 40px;
    width: 50%;
    float: left;
    border-bottom: 1px solid rgba(192, 198, 201, 0.42);
    margin-bottom: 10px;
    border: none;
    outline: none;
    background-color: #FBFDFF !important;
    color: black !important;
    font-size: 18px;
  }
  
  .setpage button:first-of-type {
    border-right: 1px solid #edf1f4;
  }

  .header {
    width: 100%;
    height: 6%;
    overflow: hidden;
    color: #fff;
    border-bottom: 1px solid rgba(92, 120, 201, 0.49);
    position: relative;
    background-image: linear-gradient(to bottom, #799fff, rgba(83, 161, 255, 0.77), #6c96ff);
  }

  .header:before {
    content: "";
    position: absolute;
    top: -10px;
    left: 0;
    width: 100%;
    height: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.8);
    z-index: 100;
  }

  .header .headtitle {
    position: absolute;
    height: 30px;
    left: 2%;
    line-height: 30px;
    top: 50%;
    margin-top: -15px;
  }

  .header .logo {
    position: absolute;
    height: 30px;
    overflow: hidden;
    line-height: 30px;
    top: 50%;
    left: 2%;
    width: 160px;
    margin-top: -15px;
  }

  .header .logo img {
    width: 100%;
    height: 100%;
  }

  .header button {
    width: 40px;
    border: none;
    outline: none;
    position: absolute;
    cursor: pointer;
    right: 30px;
    top: 50%;
    font-size: 16px;
    color: #ffffff;
    margin-top: -20px;
    height: 40px;
    background-color: transparent;

  }

  .main, .aside, .context {
    height: 94%;
    float: left;
    background-color: rgba(215, 230, 255, 0.1);
  }

  .aside {
    box-sizing: border-box;
    padding-top: 50px;
    position: relative;
    width: 15%;
    border-right: 1px solid #caccd4;
  }

  .aside .ser {
    width: 100%;
    height: 100%;
    position: relative;
    box-sizing: border-box;
    padding-top: 40px;
  }

  .search {
    width: 100%;
    height: 50px;
    position: absolute;
    left: 0;
    background-color: #53a1ff;
    top: 0;
    box-sizing: border-box;
    padding: 10px 20px;
  }

  .search input {
    width: 100%;
    text-indent: 1.5em;
    height: 30px;
    border-radius: 8px;
    outline: none;
    border: 1px solid #c8c9cb;
    line-height: 30px;

  }

  .aside .ser .list {
    width: 100%;
    height: 100%;
    overflow: auto;
  }

  .aside .ser .list ul {
    width: 100%;
    box-sizing: border-box;

  }

  .aside .ser .list ul li {
    width: 100%;
    box-sizing: border-box;
    padding: 5px 20px;
    font-size: 18px;
    cursor: pointer;
  }

  .aside .ser .list .loading {
    margin-top: 40px;
  }

  .aside .ser .list ul li.checked {
    background-color: #8eb5fa;
    color: #fff;
  }

  .aside .ser .list ul li i {
    color: #5a8cf2;
    margin-right: 10px;
  }

  .history_v {
    width: 100%;
    height: 0;
    overflow: hidden;
    box-sizing: border-box;
    border-bottom: 1px solid transparent;
    transition: all .5s ease;
  }

  .history_v .title i {
    color: #5a8cf2;
  }

  .history_cd.checked {
    color: #ffffff;
    background-color: #8eb5fa;
  }

  .history_u {
    height: auto;
    border-color: #d6ddef;
  }

  .history_cd {
    width: 100%;
    text-indent: 2em;
    font-size: 16px;
    line-height: 30px;
    box-sizing: border-box;
    cursor: pointer;
    border-bottom: 1px solid rgba(112, 119, 125, 0.24);
  }

  .list_title {
    height: 40px;
    width: 100%;
    position: absolute;
    line-height: 40px;
    font-size: 18px;
    font-weight: 600;
    top: 0;
    background-color: #ffffff;
    text-align: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.11);
  }

  .main {
    width: 70%;

  }

  .context {
    width: 15%;
    box-sizing: border-box;
    border-left: 1px solid #dbdade;
  }

  .context .select {
    height: 50px;
    box-sizing: border-box;
    padding: 10px 20px;
    background-color: #53a1ff;
  }

  .context .select select {
    height: 30px;
    width: 100%;
    border-radius: 8px;
  }

  .con_title {
    line-height: 40px;
    height: 40px;
    border-bottom: 1px solid rgba(192, 198, 201, 0.42);
    text-align: center;
  }

  .con_title h3 {
    width: 50%;
    box-sizing: border-box;
    float: left;
  }

  .con_title h3:first-of-type {
    border-right: 1px solid #edf1f4;
  }

  .con_text {
    width: 100%;
    height: 100%;
    overflow: auto;
    position: relative;
  }

  .con_text li {
    box-sizing: border-box;
    padding: 0 20px;
    height: 30px;
    font-size: 16px;
    color: #333;
    line-height: 30px;
  }
  .header .logo img{
    width: inherit;
    height: inherit;
  }
  .con_text ul .title {
    height: 40px;
    color: #000;
    line-height: 40px;
    text-align: center;
  }

  .con_text ul {
    margin-top: 10px;
  }

  .con_text ul .title i {
    color: #54a3ff;
    vertical-align: top;
    font-size: 30px !important;

  }

  .con_text ul .title span {
    vertical-align: top;
  }

  .history {
    height: 90%;
    width: 100%;
    box-sizing: border-box;
    position: relative;

    border-top: 1px solid rgba(170, 165, 179, 0.36);
  }

  .history .history_title {
    width: 100%;
    height: 40px;
    position: absolute;
    top: 0;
    color: #fff;
    line-height: 40px;
    box-sizing: border-box;
    font-size: 16px;
    text-indent: 1em;
    border-bottom: 1px solid rgba(170, 165, 179, 0.36);
    text-align: left;
    background-color: #53a1ff;
  }

  .history li {
    box-sizing: border-box;
    padding-left: 20px;
    height: 30px;
    font-size: 16px;
    color: #333;
    line-height: 30px;
  }

  .history_con {
    width: 100%;
    height: 100%;
    overflow: auto;
  }

  html {
    height: 100%;
  }

  body {
    height: 100%;
    background: #EA4961;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  body {
    background: #eaecfa;
  }

  @-webkit-keyframes enter {
    0% {
      opacity: 0;
      top: -10px;
    }
    5% {
      opacity: 1;
      top: 0px;
    }
    50.9% {
      opacity: 1;
      top: 0px;
    }
    55.9% {
      opacity: 0;
      top: 10px;
    }
  }

  @keyframes enter {
    0% {
      opacity: 0;
      top: -10px;
    }
    5% {
      opacity: 1;
      top: 0px;
    }
    50.9% {
      opacity: 1;
      top: 0px;
    }
    55.9% {
      opacity: 0;
      top: 10px;
    }
  }

  @-moz-keyframes enter {
    0% {
      opacity: 0;
      top: -10px;
    }
    5% {
      opacity: 1;
      top: 0px;
    }
    50.9% {
      opacity: 1;
      top: 0px;
    }
    55.9% {
      opacity: 0;
      top: 10px;
    }
  }

  .loadError {
    width: 100%;
    text-align: center;
    color: #b5c3d5;
  }

  @media screen and (max-width: 1600px) {
    .aside .ser .list ul li {
      font-size: 12px;
    }

    .history li {
      font-size: 12px;
    }

    .history .history_title {
      font-size: 14px;
    }

    .aside .ser {
      font-size: 14px;
    }

    .aside .list_title {
      font-size: 14px;
    }

    .loadError {
      font-size: 14px;
    }

    #demo {
      font-size: 12px;
    }

    .con_title h3 {
      font-size: 14px;
    }

    .con_text ul li {
      font-size: 12px;
    }

    .header .logo {
      width: 110px;
      height: 20px;
      margin-top: -10px;
      overflow: inherit;
    }

    .header {
      font-size: 14px;
    }

    .header button {
      font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/RoadSign/RoadSign.vue